<template>
	<m-main-layout>
		<div>
			<el-form :model="searchForm" label-width="100px" inline>
				<el-form-item label="报名企业">
					<el-input v-model="searchForm.company"></el-input>
				</el-form-item>
				<el-form-item label="报名联系人">
					<el-input v-model="searchForm.contact"></el-input>
				</el-form-item>
				<el-form-item label="报名手机">
					<el-input v-model="searchForm.phone"></el-input>
				</el-form-item>
				<el-form-item label="标讯标题">
					<el-input v-model="searchForm.title"></el-input>
				</el-form-item>
				<el-form-item label="发标企业">
					<el-input v-model="searchForm.bids_company"></el-input>
				</el-form-item>
				<el-form-item label="报名状态">
					<type-select v-model="searchForm.state" :options="[{id:1,name:'待处理'},{id:2,name:'已通过'},{id:3,name:'已拒绝'}]"></type-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="toSearch">搜索</el-button>
					<el-button type="info" @click="toReset">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-table :data="list" style="width: 100%" size="mini">
			<el-table-column label="报名企业">
				<template slot-scope="scope">
					<a :href="$config.webUrl+'/company/detail/'+scope.row.uid" target="_blank">{{scope.row.company}}</a>
				</template>
			</el-table-column>
			<el-table-column label="报名联系人">
				<template slot-scope="scope">
					{{scope.row.contact}}
				</template>
			</el-table-column>
			<el-table-column label="报名手机">
				<template slot-scope="scope">
					{{scope.row.phone}}
				</template>
			</el-table-column>
			<el-table-column label="报名标讯">
				<template slot-scope="scope">
					<a :href="$config.webUrl+'/bids/detail/'+scope.row.tid" target="_blank">{{scope.row.title}}</a>
				</template>
			</el-table-column>
			<el-table-column label="发布标讯企业">
				<template slot-scope="scope">
					<a :href="$config.webUrl+'/company/detail/'+scope.row.target_uid" target="_blank">{{scope.row.target_comapny}}</a>
				</template>
			</el-table-column>
			<el-table-column label="报名时间" prop="create_time"></el-table-column>
			<el-table-column label="状态">
				<template slot-scope="scope">
					<el-tag type="info" v-if="scope.row.state === 1">待处理</el-tag>
					<el-tag type="success" v-if="scope.row.state === 2">已通过</el-tag>
					<el-tag type="danger" v-if="scope.row.state === 3">已拒绝</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="拒绝原因" prop="reason"></el-table-column>
		</el-table>
		<div class="padding-top-bottom-20 text-center">
			<el-pagination
				background
				layout="total,prev, pager, next"
				:page-size="searchForm.pageSize"
				:current-page.sync="searchForm.page"
				:total="totalCount"
				@current-change="pageChange">
			</el-pagination>
		</div>
	</m-main-layout>
</template>

<script>
export default {
	name: "baoming",
	data() {
		return {
			searchForm:{
				tid:'',
				company:'',
				contact:'',
				phone:'',
				title:'',
				bids_company:'',
				state:'',
				page:1,
				pageSize:10
			},
			list:[],
			totalCount:0
		}
	},
	created() {
		this.searchForm.tid = this.$route.query.id ? this.$route.query.id : '';
	},
	mounted() {
		this.getList();
	},
	methods: {
		toSearch() {
			this.searchForm.page = 1
			this.getList();
		},
		toReset(){
			this.searchForm.page = 1;
			this.searchForm.company = '';
			this.searchForm.contact = '';
			this.searchForm.phone = '';
			this.searchForm.state = '';
			this.searchForm.title = '';
			this.searchForm.bids_company = '';

			this.getList();
		},
		pageChange(page){
			this.page = page;
			this.getList();
		},
		getList(){
			let _this = this;
			this.list = [];
			this.$http.httpPost({
				url:'/UserToubiaoLog/listPage',
				datas:{...this.searchForm},
				success(res){
					console.log(res);
					_this.list = res.list;
					_this.totalCount = res.totalCount;
				}
			})
		}
	}
}
</script>
